import React from 'react';
import { useFormContext } from 'react-hook-form';
import classnames from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete';
import { FileUploadDropzone } from '@Components';
import { useFileUpload } from '@Hooks';
import styles from './FileUpload.module.scss';
import { DropzoneOptions } from 'react-dropzone';
import { RiFileTextLine } from 'react-icons/ri';
import { Link } from '../Link/Link';

export const FileUpload = ({
  fieldName,
  config,
  title,
  subTitle,
  header,
  required,
}: {
  fieldName: string;
  config: DropzoneOptions;
  title?: string;
  subTitle?: string;
  header?: string;
  required?: boolean;
}) => {
  const { errors: fieldErrors, watch } = useFormContext();

  const { file, deleteFile, dropzoneInputProps, dropzoneRootProps } = useFileUpload({
    fieldName: fieldName,
    uploadConfig: config,
  });

  const loadedFiles = watch(fieldName);

  const isDropzoneHidden =
    Array.isArray(file) || typeof file === 'string' || loadedFiles?.length > 0;

  return (
    <div className={styles.container}>
      <h4>{title}</h4>
      <p>{subTitle}</p>
      <FileUploadDropzone
        fieldName={fieldName}
        dropzoneInputProps={dropzoneInputProps}
        dropzoneRootProps={dropzoneRootProps}
        header={header}
        className={classnames(
          isDropzoneHidden && styles.hidden,
          fieldErrors[fieldName]?.message && styles.error,
        )}
        required={required}
      />

      {isDropzoneHidden && (
        <div className={styles.previewWrapper}>
          {Array.isArray(file) || Array.isArray(loadedFiles) ? (
            (file?.length ? file : loadedFiles)?.map((item: { name: string; url: string }) => (
              <div className={styles.fileList} key={item.name}>
                <RiFileTextLine size={20} />
                {item.url ? (
                  <Link underline href={item.url}>
                    {item.name}
                  </Link>
                ) : (
                  item.name
                )}
              </div>
            ))
          ) : (
            <div className={styles.fileList}>
              <RiFileTextLine size={20} />
              <p>{file}</p>
            </div>
          )}

          <button onClick={deleteFile} className={styles.deleteIcon}>
            <DeleteIcon style={{ fontSize: 20 }} />
          </button>
        </div>
      )}

      {fieldErrors[fieldName]?.message && (
        <p className={styles.errorMessage}>{fieldErrors[fieldName].message}</p>
      )}
    </div>
  );
};
